import { ShimmerEffect } from "@/components/shimmer";
import React from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "ui/components/card";

export default function CommonCard({
  title,
  info,
  children,
  contentClassName = "flex-1 pb-6",
  onClick,
  cardData,
  percentage,
  progressColor, // Optional: if provided, overrides the default logic
  isLoading = false,
}) {
  const getProgressColor = (value) => {
    if (progressColor) return progressColor;
    if (value > 81) return "#4CAF50"; // Green
    if (value >= 61) return "#FF9800"; // Orange
    return "#F44336"; // Red
  };

  const activeColor = getProgressColor(percentage);
  return (
    <Card
      className="flex flex-col cursor-pointer hover:shadow-md transition-shadow min-w-xs [&_*]:!cursor-pointer"
      onClick={() => onClick && onClick(cardData)}
    >
      <CardHeader className="items-start  flex flex-row space-y-0">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className={contentClassName + " cursor-pointer pb-0"}>
        {percentage !== undefined ? isLoading ? <div className="flex flex-col justify-center gap-2"> <ShimmerEffect className="h-10 w-32" /> <ShimmerEffect className="h-2 w-68" /></div> : (
          <div className="space-y-3">
            <div className="text-3xl font-bold">{percentage}%</div>
            <div className="relative h-2 w-full overflow-hidden rounded-full bg-muted">
              <div
                className="h-full w-full flex-1 transition-all"
                style={{
                  backgroundColor: activeColor,
                  transform: `translateX(-${100 - (percentage || 0)}%)`
                }}
              />
            </div>
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
